import Reflux, { RefluxAction } from "reflux";

const CustomerDeleteAddressAction: RefluxAction<any> = Reflux.createAction({
    asyncResult: true
});

export default CustomerDeleteAddressAction;
